import React from 'react';

import './contactCaption.scss';

const ContactCaption = () => {
    return (
        <div className='contact-caption'>
            <div className='contact-caption-contact'>
                CONTACT
                <span>  Us</span>
                <span className='hiven'>!</span>
            </div>
            <div className='text'>Speak to a representative on our services,Book services report service issues,
             make enquiries,suggestions and complaints.</div>
        </div>
    )
}

export default ContactCaption;
